import {Cureus} from '../Cureus';

Cureus.ReviewerRating = (function($, _) {
  var init, ReviewerRating, StarWidget;
  var SLIDE_WIDTH = 564;

  init = function(modalSelector) {
    new ReviewerRating(modalSelector);
  };

  ReviewerRating = function(modalSelector) {
    this.modalSelector = modalSelector;
    this.$modal = $(modalSelector);
    this.totalSlides = this.countNumSlides();
    this.currentSlide = 0;
    this.$nextButton = this.$modal.find(".next-rating");
    this.$prevButton = this.$modal.find(".prev-rating");
    this.$submitButton = this.$modal.find("#submit");
    this.$slider = this.$modal.find("ul");
    this.$slideNumber = this.$modal.find("[data-slide-number]");

    this.setupSlider();
    this.bindButtonEvents();
    this.toggleDisabledButtons();
    this.toggleButtonDisplay();
    this.initializeStarWidget();
  };

  _.extend(ReviewerRating.prototype, {
    setupSlider: function() {
      var width = this.totalSlides * SLIDE_WIDTH;
      this.$modal.find("ul").css('width', width);
    },
    bindButtonEvents: function() {
      var self = this;

      this.$nextButton.click(function(e) {
        self.nextSlide();
        self.updateButtons();
        self.updateSlideNumber();
        e.preventDefault();
      });

      this.$prevButton.click(function(e) {
        self.prevSlide();
        self.updateButtons();
        self.updateSlideNumber();
        e.preventDefault();
      });

      this.$submitButton.click(function(e) {
        e.target.addClass("disabled")
        if(e.target.innerText !== 'Next') {
          e.target.innerHTML = "Submitting..."
        }
        e.preventDefault();
      });
    },

    updateButtons: function() {
      this.toggleButtonDisplay();
      this.toggleDisabledButtons();
    },

    updateSlideNumber: function() {
      var slideNumber = (this.currentSlide + 1) + " of " + this.totalSlides;
      this.$slideNumber.html(slideNumber);
    },

    toggleDisabledButtons: function() {
      if(this.onFirstSlide()) {
        this.$prevButton.addClass("disabled");
      } else {
        this.$prevButton.removeClass("disabled");
      }

      if(this.currentSlideIsRated()) {
        this.$nextButton.removeClass("disabled");
        if(this.onLastSlide()){
          this.$submitButton.removeAttr("disabled");
        }
      } else {
        this.$nextButton.addClass("disabled");
      }
    },

    toggleButtonDisplay: function (){
      if(this.onLastSlide()){
        this.hideNextButton();
        this.showSubmitButton();
      }else{
        this.showNextButton();
        this.hideSubmitButton();
      }
    },

    hideNextButton: function (){
      this.$nextButton.hide();
    },

    showNextButton: function (){
      this.$nextButton.show();
    },
    hideSubmitButton: function (){
      this.$submitButton.hide();
    },
    showSubmitButton: function (){
      this.$submitButton.show();
    },

    nextSlide: function() {
      if(this.onLastSlide()) { return; }

      if(this.currentSlideIsRated()) {
        this.currentSlide += 1;
        var slideAmt = this.currentSlide * -SLIDE_WIDTH;
        this.animateSlide(slideAmt);
      }
    },

    prevSlide: function() {
      if(this.onFirstSlide()) { return; }

      this.currentSlide -= 1;
      var slideAmt = this.currentSlide * -SLIDE_WIDTH;
      this.animateSlide(slideAmt);
    },

    animateSlide: function(slideAmt) {
      this.$slider.css("transform", "translateX(" + slideAmt + "px)");
    },

    countNumSlides: function (){
      return this.$modal.find("li").length;
    },

    getCurrentSlide: function() {
      return $(this.$modal.find("li")[this.currentSlide]);
    },

    currentSlideIsRated: function() {
      return this.getCurrentSlide().find(".rating-field").val() != "";
    },

    onFirstSlide: function() {
      return this.currentSlide == 0;
    },

    onLastSlide: function() {
      return this.currentSlide == (this.totalSlides - 1);
    },

    initializeStarWidget: function() {
      var self = this;

      _.each(this.$modal.find(".reviewer-rating"), function(reviewerRating, index) {
        var widget = new StarWidget(reviewerRating);
        $(widget).on("starwidget:value-set", function() {
          self.toggleDisabledButtons();
        });
      });
    }
  });

  StarWidget = function(starWrapperSelector) {
    this.$starWrapper = $(starWrapperSelector);
    this.stars = this.$starWrapper.find("i.far"); //maybe find %i, and initalize them with star empties
    this.$ratingField = this.$starWrapper.find(".rating-field");
    this.bindStarEvents();
  }

  _.extend(StarWidget.prototype, {
    bindStarEvents: function() {
      var self = this;

      _.each(self.stars, function(star, index) {
        $(star).on("mouseover", function() {
          self.renderStars(index);
        });
        
        self.$starWrapper.on('mouseleave', function (){
          self.renderStars(self.getRatingField() - 1);
        });

        $(star).on("touchstart", function (e){
          self.renderStars(index);
        });

        $(star).on("click", function(e) {
          if(self.$ratingField.val() == '') {
            self.$ratingField.trigger("first-rating-chosen");
          }
          self.setRatingField(index + 1);
        });
      });
    },

    renderStars: function(index) {
      //highlight things up until index
      for(var i = 0; i <= index; i++) {
        var $star = $(this.stars[i]);
        $star.removeClass("far");
        $star.addClass("fas");
      }

      //unhighlight things after index
      for(var i = index + 1; i < this.stars.length; i++) {
        var $star = $(this.stars[i]);
        $star.removeClass("fas");
        $star.addClass("far");
      }
    },

    setRatingField: function(value) {
      this.$ratingField.val(value);
      $(this).trigger("starwidget:value-set");
    },

    getRatingField: function() {
      return this.$ratingField.val() || 1;
    }
  }); 
  return { init: init };
})(jQuery, _);
